import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { Grid, Menu, Segment } from 'semantic-ui-react';
import { USER_PERMISSIONS, PRODUCT_PERMISSIONS } from 'dyl-components';
import RestrictedView from 'shared/RestrictedView';

const ROUTES = {
    ringGroupCallQueues: 'ring-group-call-queues', 
    destinationGroups: 'destination-groups',
    ivrPrompts: 'ivr-prompts',
    callRoutingRules: 'call-routing-rules'
}

const Routing = () => {
    return <Grid>
        <Grid.Row style={{ paddingTop: 0, paddingBottom: 0 }}>
            <Grid.Column style={{ paddingTop: '1em', paddingRight: 0, paddingLeft: '0.5em' }}>
                <Menu secondary className='PhoneManagement_generalTabs'>
                    <RestrictedView type="disabled" productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}routing/${ROUTES.ringGroupCallQueues}`} userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
                        <Menu.Item as={NavLink} to={ROUTES.ringGroupCallQueues}> Ring Groups/Call Queues </Menu.Item>
                    </RestrictedView>
                    <RestrictedView type="disabled" productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}routing/${ROUTES.destinationGroups}`} userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
                        <Menu.Item name='Destination Groups' as={NavLink} to={ROUTES.destinationGroups} />
                    </RestrictedView>
                    <RestrictedView type="disabled" productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}routing/${ROUTES.ivrPrompts}`} userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
                        <Menu.Item name='IVR Prompts' as={NavLink} to={ROUTES.ivrPrompts} />
                    </RestrictedView>
                    <RestrictedView type="disabled" productPermission={`${PRODUCT_PERMISSIONS.SETTINGS_PHONE_MANAGEMENT}routing/${ROUTES.callRoutingRules}`} userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_VIEW}>
                        <Menu.Item name='Call Routing Rules' as={NavLink} to={ROUTES.callRoutingRules} />
                    </RestrictedView>
                </Menu>
                <Segment basic>
                    <Outlet />
                </Segment>
            </Grid.Column>
        </Grid.Row>
    </Grid>;
}

export default Routing;